module.exports = __webpack_public_path__ + "img/HPS021NG.f3ef3d5c.png";